// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"nJ-z","carouselContainer":"oJ-z"};